import { Observable, from, of, timer } from "rxjs";
import { ofType } from "redux-observable";
import { catchError, map, mapTo, switchMap, takeUntil } from "rxjs/operators";
import { LoadSessions, LoadSessionsError, LoadSessionsSuccess, SessionAction, SessionActions, StartSessionsPoll } from "../actions/sessions";
import { CreateErrorNotice } from "../../store/actions/toaster.action";
import { Session } from "../../shared/models/session";
import SessionsService from "../services/sessions.service";

const JOBS_POLL_TIME = 30*1000;

const getSessionsEpic = (action$: Observable<SessionAction>) => action$.pipe(
  ofType<LoadSessions>(SessionActions.LoadSessions),
  switchMap((action) => from(SessionsService.getSessions(action.orgID, action.params)).pipe(
    map((data: Session[]) => new LoadSessionsSuccess(data)),
    catchError((error: Error) => of(
      new LoadSessionsError(error.message || 'Unknown session fetching error.'),
      new CreateErrorNotice('Error', 'Failed to load sessions.'),
    )),
  ))
);

export const sessionsPollEpic = (action$: Observable<SessionAction>) => action$.pipe(
  ofType<StartSessionsPoll>(SessionActions.StartSessionsPoll),
  switchMap((action) => {
    return timer(0, JOBS_POLL_TIME).pipe(
      mapTo(new LoadSessions(action.orgID, action.params)),
      takeUntil(action$.pipe(
        ofType(SessionActions.StopSessionsPoll)
      ))
    );
  })
);

const SessionEpics = [
  sessionsPollEpic,
  getSessionsEpic,
];

export default SessionEpics;